module.exports = __webpack_public_path__ + "static/img/Partner2@2x.f4f79e82.png";